import React, { Component } from "react";
import { Route } from "react-router-dom";

import SpaceBlocks from "./SpaceBlocks";
import HighScoreTable from "./HighScoreTable";
import PlayerInput from "./PlayerInput";
import GameMenu from "./GameMenu";
import Controls from "./Controls";

class Game extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playerLevel: "",
      playerScore: 0,
      highscoreCrypto: "",
    };
    this.updatePlayerLevel = this.updatePlayerLevel.bind(this);
    this.updatePlayerScore = this.updatePlayerScore.bind(this);
    this.updateHighscoreCrypto = this.updateHighscoreCrypto.bind(this);
  }

  updatePlayerLevel(level) {
    let levelInt = 1;
    switch (level) {
      case "one":
        levelInt = 1;
        break;
      case "two":
        levelInt = 2;
        break;
      case "three":
        levelInt = 3;
        break;
      case "four":
        levelInt = 4;
        break;
      case "five":
        levelInt = 5;
        break;
      case "six":
        levelInt = 6;
        break;
      case "seven":
        levelInt = 7;
        break;
      case "eight":
        levelInt = 8;
        break;
      case "nine":
        levelInt = 9;
        break;
      case "ten":
        levelInt = 10;
        break;
      case "eleven":
        levelInt = 11;
        break;
      case "twelve":
        levelInt = 12;
        break;
      case "thirteen":
        levelInt = 13;
        break;
      case "fourteen":
        levelInt = 14;
        break;
      case "fifteen":
        levelInt = 15;
        break;
      case "victory":
        levelInt = 99;
        break;

      default:
        break;
    }
    this.setState({
      playerLevel: levelInt,
    });
  }
  updatePlayerScore(score) {
    this.setState({
      playerScore: score,
    });
  }

  updateHighscoreCrypto(highscoreCrypto) {
    this.setState({
      highscoreCrypto: highscoreCrypto,
    });
  }

  render() {
    const myGame = () => {
      return (
        <SpaceBlocks
          updateLevel={this.updatePlayerLevel}
          updateScore={this.updatePlayerScore}
          updateHighscoreCrypto={this.updateHighscoreCrypto}
          gameState={false}
        />
      );
    };
    const inputScreen = () => {
      return (
        <PlayerInput
          level={this.state.playerLevel}
          score={this.state.playerScore}
          highscoreCrypto={this.state.highscoreCrypto}
        />
      );
    };
    return (
      <div id="game-page">
        <Route exact path="/spaceblocks" component={GameMenu} />
        <Route path="/spaceblocks/play" render={myGame} />
        <Route path="/spaceblocks/scores" component={HighScoreTable} />
        <Route path="/spaceblocks/input" render={inputScreen} />
        <Route path="/spaceblocks/controls" render={Controls} />
      </div>
    );
  }
}

export default Game;
